import { render } from "./App.vue?vue&type=template&id=7b455d52"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "../node_modules/bounce-ui-vue/dist/bounce_ui.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=7b455d52&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__